// extracted by mini-css-extract-plugin
export default {"wrapper":"WG","content":"XG","firstSection":"YG","text":"ZG","table":"aH","tableText":"bH","row":"cH","column_2":"eH","column_1":"fH","column_3":"gH"};
    if(module.hot) {
      // 1711717533681
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  